// extracted by css-extract-rspack-plugin
export default {"Well":"xrQav","ToggleIcon":"hLIrA","active":"vGorH","InnerLabel":"v0sZh","activeLabel":"tLmnc"};